// extracted by mini-css-extract-plugin
export default {"icon":"carModelDetailsTable_icon__ryq3n","row":"carModelDetailsTable_row__35vj1"};